module.exports = __webpack_public_path__ + "images/assets/cbef336831f1c7c0a5ba02f1af467677.svg";